import { render, staticRenderFns } from "./ContentModuleSmall.vue?vue&type=template&id=dc688858&scoped=true"
import script from "./ContentModuleSmall.vue?vue&type=script&lang=js"
export * from "./ContentModuleSmall.vue?vue&type=script&lang=js"
import style0 from "./ContentModuleSmall.vue?vue&type=style&index=0&id=dc688858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc688858",
  null
  
)

export default component.exports